<template lang="pug">
	.timeline-message-media
		//- Image media
		.media-images(
			v-if="images.length > 0"
		)

			//- Single image
			figure.image(v-if="images.length === 1")
				img(:src="getMediaThumbnailURL(images[0])")

			//- Slider if more than one image
			.gallery(v-else)
				.glide(ref="mediaSlider")
					//- Slides
					.glide__track(data-glide-el="track")
						.glide__slides(ref="mediaSliderSlides")
							.glide__slide(v-for="mediaItem in images")
								img(:src="getMediaThumbnailURL(mediaItem)", :width="mediaItem.thumbnail.imageSize.width", :height="mediaItem.thumbnail.imageSize.height")

					//- Slider navigation arrows
					.glide__arrows(data-glide-el="controls")
						button.button.is-primary.glide__arrow.glide__arrow--left(data-glide-dir="<"): img(width="10" height="16" src="./../assets/img/chevron-left.svg")
						button.button.is-primary.glide__arrow.glide__arrow--right(data-glide-dir=">"): img(width="10" height="16" src="./../assets/img/chevron-right.svg")
					//- Slider bullets
					.glide__bullets(data-glide-el="controls[nav]")
						button.glide__bullet(v-for="(_, index) in media" :data-glide-dir="'=' + index")

		//- Audio files
		.media-audio(
			v-if="audios.length > 0"
		)
			.audio(
				v-for="audio in audios"
			)
				audio(
					controls
					:src="getMediaProcessedURL(audio)"
					:type="audio.processed.contentType"
				) Ihr Browser kann dieses Tondokument nicht wiedergeben. #[a(:href="getMediaProcessedURL(audio)", target="_blank") Sie können die Audio-Datei hier herunterladen]

		//- Goal player portrait
		//- transition(name="portrait", :appear="true")
		//- 	img.player-portrait(v-if="action === 'goal'", src="@/assets/img/serra-jubel.png")

</template>

<script>

import Glide from '@glidejs/glide'
import '@glidejs/glide/dist/css/glide.core.css'
import '@glidejs/glide/dist/css/glide.theme.css'

import ArrowDisabler from '../util/GlideArrowDisabler'

import mediaMixin from '../mixins/mediaMixin'

export default {
	mixins: [
		mediaMixin
	],
	props: {
		media: {
			type: Array,
			default: () => [],
			required: false
		},
		action: {
			type: String
		}
	},
	mounted () {
		this.initSlider()
	},
	computed: {
		images () {
			return this.media
				.filter(m => m != null)
				.filter(m => m.mediaType === 'image')
				.filter(m => m.thumbnail != null)
		},
		audios () {
			return this.media
				.filter(m => m != null)
				.filter(m => m.mediaType === 'audio')
				.filter(m => m.processed != null)
		}
	},
	watch: {
		async images (newMedia, oldMedia) {
			this.$nextTick(() => {
				if (this.slider) {
					this.slider.destroy()
					this.slider = null
				}
				this.initSlider()
			})
		}
	},
	methods: {
		initSlider () {
			if (this.images.length > 1 && this.$refs.mediaSlider) {
				this.slider = new Glide(this.$refs.mediaSlider, {
					type: 'slider',
					startAt: 0,
					perView: 1,
					rewind: false,
					gap: 25,
					peek: 0,
					keyboard: false
				})
				this.slider.mount({ ArrowDisabler })
			} else {
				// Do nothing
				// Dont init glide.js for 1 image
			}
		}
	}
}
</script>

<style lang="scss" scoped>
	@import '../style/variables.scss';
	.timeline-message-media {

		figure.image {
			margin-left: 0;
			margin-right: 0;

			img {
				height: auto;
				width: auto;
				max-height: 100%;
				max-width: 100%;
				width: 100%;
				object-fit: contain;
				max-height: 600px;
			}
		}
		.media-images,
		.media-audio {
			margin-top: 0.5em;
		}

		.glide {
			.button.glide__arrow {
				position: absolute;
				border-radius: 0;
			}

			button.glide__bullet {
				background-color: rgba($primary, 0.5);
				&.glide__bullet--active {
					background-color: $primary;
				}
				&:hover, &:focus {
						border: 0;
				}
				&:hover {
					background-color: $secondary;
				}
			}

			.glide__slides {
				align-items: center;
				text-align: center;
				img {
					max-height: 500px;
					width: auto;
				}
			}

			@media screen and (max-width: 768px) {
				.button.glide__arrow {
					display: none;
				}
			}

		}
	}
</style>
